import PropTypes from 'prop-types';
import { PriceSlider } from '@bwoty-web/ui-kit';

import './priceFilterContent.scss';

const PriceFilterContent = (props) => {
  const { siteId, labels, minPrice, maxPrice, selectedMaxPrice, setSelectedMaxPrice, removeMaxPriceFilter } = props;

  const onSliderChange = (value) => {
    const valueInt = parseInt(value, 10);
    if (valueInt >= maxPrice) {
      removeMaxPriceFilter();
    } else {
      setSelectedMaxPrice(valueInt);
    }
  };

  return (
    <div className="po-list-price-filter-content">
      <PriceSlider
        className="po-list-price-filter-slider"
        uniqueId="po-list-price-filter-slider"
        min={minPrice}
        max={maxPrice}
        value={selectedMaxPrice === null ? maxPrice : selectedMaxPrice}
        mucd={siteId}
        valueLabel={labels.priceUpTo}
        onChange={onSliderChange}
      />
    </div>

  );
};

PriceFilterContent.propTypes = {
  siteId: PropTypes.number.isRequired,
  labels: PropTypes.shape({
    priceUpTo: PropTypes.string.isRequired,
  }).isRequired,
  minPrice: PropTypes.number.isRequired,
  maxPrice: PropTypes.number.isRequired,
  selectedMaxPrice: PropTypes.number,
  setSelectedMaxPrice: PropTypes.func.isRequired,
  removeMaxPriceFilter: PropTypes.func.isRequired,
};

PriceFilterContent.defaultProps = {
  selectedMaxPrice: null,
};

export default PriceFilterContent;
